import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setCountry, setCountryName } from "./formSlice";
import { setLanguageData } from "./languageOptionsSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchWelcomeScreen = createAsyncThunk(
  "welcomeScreen/fetchWelcomeScreen",
  async (language) => {
    return fetch(`${baseUrl}/api/welcome-screen/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Accept-Language": language,
      },
    }).then((res) => errorStatusProvider(res));
  }
);

export const getWelcomeScreen =
  (language, useCode = true, countryQuery = null) =>
  async (dispatch) => {
    const result = await dispatch(fetchWelcomeScreen(language));

    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));

    if (countryQuery) {
      dispatch(setLanguageData(countryQuery.toUpperCase()));
      dispatch(
        setCountry(
          data?.page_content.countries.filter(
            (c) => c.country_code === countryQuery.toUpperCase()
          )[0].country_name
        )
      );

      return dispatch(
        setCountryName(
          data?.page_content.countries.filter(
            (c) => c.country_code === countryQuery.toUpperCase()
          )[0].country_code
        )
      );
    }

    if (useCode)
      dispatch(setLanguageData(data?.page_content?.countries[0]?.country_code));

    dispatch(setCountry(data?.page_content?.countries[0]?.country_name));

    return dispatch(
      setCountryName(data?.page_content?.countries[0]?.country_code)
    );
  };

export const welcomeScreenSlice = createSlice({
  name: "welcomeScreen",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWelcomeScreen.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWelcomeScreen.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload?.data?.page_content;
      })
      .addCase(fetchWelcomeScreen.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default welcomeScreenSlice.reducer;
